import type { ChangeEvent, FC, FocusEvent, ReactElement } from 'react'

import type { WhiteLabel } from '@skytech/types'

import { ErrorMessage } from '../ErrorMessage'
import { Label } from '../Label'

import './styles.scss'

export const Textarea: FC<{
  id: string
  isFullWidth?: boolean
  isFullHeight?: boolean
  className?: string
  label?: string | ReactElement
  value?: string
  type?: string
  error?: string
  touched?: boolean
  placeholder?: string
  marginBottom?: number
  marginTop?: number
  capitalizeLabel?: boolean
  isDisabled?: boolean
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void
  onBlur?: (e: FocusEvent<unknown, Element>) => void
  maxLength?: number
  rows?: number
}> = ({
  id,
  value,
  placeholder,
  className = '',
  label,
  error,
  touched,
  isFullWidth,
  marginBottom,
  marginTop,
  capitalizeLabel,
  isDisabled,
  isFullHeight,
  onChange,
  onBlur,
  maxLength,
  rows = 4,
}) => {
  const errorClass = error && touched ? 'has-error' : ''
  const fullWidthClass = isFullWidth ? 'is-full-width' : ''
  const fullHeightClass = isFullHeight ? 'grow' : ''

  // todo: replace with the org from url when ready
  const whiteLabel = localStorage.getItem('org') as WhiteLabel

  return (
    <div
      className="flex flex-col px-1"
      style={{
        marginBottom: marginBottom || 0,
        marginTop: marginTop || 0,
        height: isFullHeight ? '100%' : '',
      }}
    >
      {label && (
        <Label capitalizeLabel={capitalizeLabel} htmlFor={id}>
          {label}
        </Label>
      )}

      <textarea
        id={id}
        className={`ui-textarea transition-all ${errorClass} ${className} ${fullWidthClass} ${fullHeightClass} ${whiteLabel}`}
        value={value}
        placeholder={placeholder}
        disabled={isDisabled}
        onChange={onChange}
        rows={rows}
        // Crucial for setting the "touched" fields
        onBlur={onBlur}
        maxLength={maxLength}
      />

      {error && touched && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  )
}
